<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .usage {
    height: utils.in_rem(20px);
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.25rem;
    @include mixins.body4();
    display: flex;
    padding-bottom: utils.in_rem(6px);
    .text {
      @include mixins.h5();
      text-align: right;
    }
  }
</style>

<script>
  import Icon from "../../../atoms/Icon.svelte";
  import Tooltip from "../../../atoms/Tooltip.svelte";

  let { activeCount, total, skeleton, status, type } = $props();
  let isTrial = $derived(status === "trial");
  let s = $derived(activeCount === 1 ? "" : "s");
  let hasNoLicenses = $derived(total === 0 && !isTrial);
</script>

<div class="usage">
  {#if isTrial}
    <span class="text" class:skeleton>{activeCount} trial user{s}</span>
  {:else if hasNoLicenses}
    {#if type === "external"}
      <Tooltip let:onmouseenter let:onmouseleave>
        <span slot="tooltip">Add licenses to get your team started!</span>
        <span {onmouseenter} {onmouseleave} role="note" class="text">
          No licenses available
          <Icon size="xs" class="fa-regular fa-circle-exclamation" />
        </span>
      </Tooltip>
    {:else}
      <span class="text" class:skeleton> No licenses available </span>
    {/if}
  {:else if activeCount >= total}
    <Tooltip let:onmouseenter let:onmouseleave>
      <span slot="tooltip"
        >License limit reached: {activeCount} of {total} are assigned.</span
      >
      <span {onmouseenter} {onmouseleave} role="note" class="text">
        License limit reached
        <Icon size="xs" class="fa-regular fa-circle-exclamation" />
      </span>
    </Tooltip>
  {:else}
    <span class="text" class:skeleton>{activeCount}/{total} users</span>
  {/if}
</div>
